export default __webpack_public_path__ + "static/media/city-hall-email.e111895f.svg";